// 钉钉微应用实名认证 (完善信息)
<template>
<no-ssr>
  <div class="ding-auth-sty">
  <h1 class="font-red">完善信息</h1>
  <div class="auth-content">
      <h3 class="titleII">
        <span class="title-icon"></span>
        <template>
          <span v-if="loginInfo.corpAuthed !=1">当前认证企业：{{loginInfo.dingTalkCorpName}}</span>
          <span v-else>个人实名认证</span>
        </template>
        
      </h3>
      <div class="flex-row-center">
        <el-form
          ref="authFormRef"
          :model="enterprise"
          :rules="enterpriseRules"
          label-position="right"
          label-width="150px"
        >
          <el-form-item label="企业名称：" prop="enterpriseName">
            <el-input
              placeholder="请输入企业名称"
              v-model="enterprise.enterpriseName"
              :style="{width:inputWidth}"
            ></el-input>
          </el-form-item>
          <el-form-item label="邮箱：" prop="email">
            <el-input placeholder="请输入邮箱号码" v-model="enterprise.email" :style="{width:inputWidth}"></el-input>
          </el-form-item>
          <el-form-item label="验证码：" prop="code">
            <el-input
              v-model="enterprise.code"
              auto-complete="off"
              placeholder="输入验证码"
              :style="{width:inputWidth}"
            >
              <el-button slot="append" class="append-sty" @click.prevent="regestEmail">获取验证码</el-button>
            </el-input>
          </el-form-item>
        </el-form>
      </div>

      <el-button type="primary" class="auth-band" @click="bandAuthBy">下一步</el-button>
    </div>
    <!-- 图形验证码弹窗 -->
    <el-dialog title="提示" :visible.sync="imgCodeVisi" width="30%" :close-on-click-modal="false">
      <el-input
        v-model="enterprise.code_copy"
        class="input-width"
        auto-complete="off"
        placeholder="输入图形验证码"
      >
        <template slot="append">
          <span class="img-code" @click="getImgCode">
            <img :src="'data:image/png;base64,' + imgAuth.imgPath" />
          </span>
        </template>
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="imgCodeVisi = false">取 消</el-button>
        <el-button type="primary" @click="getRegistCode">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</no-ssr>

</template>
<script>
import { email } from "@/assets/js/lib/valid-methods";
import { dingtalkApi } from "@/assets/js/http-serve/dingtalkApi";

// ⚠️ dingtalk-jsapi 只能在客户端（浏览器）中使用
let dd = null;
if (process.client) {
  dd = require('dingtalk-jsapi');
}

export default {
  layout: 'fullpage',
  data () {
    // 这里存放数据
    return {
      imgAuth: '',
      imgCodeVisi: false,
      inputWidth: '460px',
      loginInfo: { dingTalkCorpName: '' },
      enterprise: {
        enterpriseName: "",
        email: "",
        imgCode: "",
        code_copy: ""
      },
      enterpriseRules: {
        email: [
          { required: true, message: "请输入邮箱号码", trigger: "blur" },
          { validator: email, trigger: "change" },
          // { validator: this.vaildEmailExit, trigger: "blur" }
        ],
        code: [
          { required: true, message: "请输入验证码", trigger: "blur" }
        ],
        enterpriseName: [
          { required: true, message: "企业名称不能为空", trigger: "blur" }
        ]
      },
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    /** 立即绑定 */
    bandAuthBy () {
      this.$refs.authFormRef.validate((valid) => {
        if (valid) {
          const _this = this, { dingTalkUserId, dingTalkCorpId: corpId } = this.loginInfo, { code, email } = this.enterprise;
          const param = {
            dingTalkUserId,
            corpId,
            code,
            email
          }
          dingtalkApi.entReplenish(param).then(res => {
            if (!res.success){
              if(res.code === '10302') return _this.$message.error('当前账号已在君子签注册，请前往绑定')
              return _this.$message.error(res.description)}
            _this.$router.push({
              path: "/dingtalkUse/middlePage",
              query: { ap: "/auth/authGuide", t: res.data.jzqToken }
            }, () => { });
          })
        }
      });
    },
    /** 获取验证码 */
    getRegistCode () {
      const _this = this, { dingTalkUserId, dingTalkCorpId: corpId } = this.loginInfo;
      if (!_this.enterprise.email) return this.$message.warning('请输入邮箱号码')
      if (!_this.enterprise.code_copy) return this.$message.warning('请输入图形验证码')
      const param = {
        corpId,
        dingTalkUserId,
        imageCode: _this.imgAuth.imgToken + "_" + _this.enterprise.code_copy,
        targetId: _this.enterprise.email
      }
      dingtalkApi.registerCodeSend(param).then(res => {
        if (!res.success) return _this.$message.error(res.description)
        _this.$message.success('已发送至邮箱')
      }).finally(() => { this.imgCodeVisi = false })
    },
    /** 获取图形验证码 */
    getImgCode () {
      const _this = this;
      _this.$refs.authFormRef.validateField(['email'], (valid) => {
        if (!valid) {
          const corpId = sessionStorage.getItem("corpId"),
            { dingTalkUserId } = _this.loginInfo;
          let param = {
            corpId,
            dingTalkUserId
          };
          dingtalkApi.getImgCode(param).then(({ data }) => {
            _this.enterprise.code_copy = ''
            _this.imgAuth = data;
            _this.imgCodeVisi = true
          });
        }
        // 验证end
      })
    },
    /** 验证邮箱是否注册 */
    regestEmail(){
      const _this = this;
      _this.$refs.authFormRef.validateField(['email'], (valid) => {
        if (!valid) {
          const { dingTalkUserId, dingTalkCorpId: corpId } = _this.loginInfo, { code, email } = _this.enterprise;
          dingtalkApi.checkRegister({ corpId, dingTalkUserId, email }).then(res => {
            if (!res.success) return _this.$message.error(res.description)
            const { exists, identityAuth } = res.data
            // 【exists】填写的邮箱是否已在君子签注册
            exists ? _this.$message.warning(`当前账号已在君子签注册，请前往绑定`) : _this.getImgCode()
          })
        }
        // 验证end
      })
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    // dd.ready 已移至 mounted，mounted 只在客户端执行，避免 SSR 调用钉钉 API
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    if (dd) {
      dd.ready(() => {
        const session = sessionStorage
        this.loginInfo = JSON.parse(session.getItem("dingloginInfo"));
        this.enterprise.enterpriseName = this.loginInfo.dingTalkCorpName;
      })
    }
  },
}
</script>

<style lang='less' scoped>
@import (less) "../../../assets/style/cssVariable.less"; // 引入公共css类
.ding-auth-sty {
  width: 75vw;
  height: 90vh;
  padding-top: 20px;
  margin: 0 auto;
  background-color: @ebq-white;
  .font-red {
    color: @ebq-red;
  }
  h1 {
    text-align: center;
    font-size: 20px;
    margin-bottom: 20px;
  }
  .auth-content {
    width: 60vw;
    margin: 0 auto;
    .append-sty {
      color: @ebq-white;
      background-color: @ebq-red;
      border-color: @ebq-red;
    }
    .band-form-sty {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .auth-band {
      display: block;
      margin: 0 auto;
      width: 20vw;
      margin-top: 10vh;
    }
  }
  .titleII {
    display: flex;
    align-items: center;
    font-size: 15px;
    margin: 10vh 0;
  }
  .title-icon {
    display: inline-block;
    width: 5px;
    height: 15px;
    margin-right: 10px;
    background-color: @ebq-title-icon-color;
  }
}
.img-code {
  background-color: #fff;
  display: inline-block;
  margin: 0 -20px;
  width: 100px;
  line-height: 30px;
  text-align: center;
  cursor: pointer;

  img {
    vertical-align: middle;
    display: inline-block;
    height: 38px;
    width: 100%;
  }
}
.flex-row-center {
  display: flex;
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// pages/auth/dingTalkAuthComponents/dingentAuth.vue